import axios from "axios";
import { i18n } from "../i18n/i18n.js";

const state = {
  contacts: [],
  contact: {},
  loadContact: false
};

const getters = {
  getContacts(state) {
    return state.contacts;
  },
  getContact(state) {
    return state.contact;
  },
  loadContact(state) { return state.loadContact}
};

const actions = {
  callContacts({ commit, getters }, data) {
    return axios
      .get("/vue/company/" + data.company + "/contacts/", {
        headers: { Authorization: "Token " + getters.getUserToken }
      })
      .then(response => {
        if (response.data.status) {
          commit("SET_CONTACTS", response.data.data.contacts);
        } else {
          data.self.$toastr("error", response.data.message, i18n.t("error"));
        }
      })
      .catch(err => {
        data.self.$toastr("error", err.message, i18n.t("error"));
      });
  },
  callContactDetails({ state, commit, getters }, data) {
    state.loadContact = true
    return axios
      .get("/vue/contact/" + data.coid + "/detail/", {
        headers: { Authorization: "Token " + getters.getUserToken }
      })
      .then(response => {
        state.loadContact = false
        if (response.data.status) {
          commit("SET_CONTACT", response.data.data);
          //console.log ("CONTACT", response.data.data)
        } else {
          data.self.$toastr("error", response.data.message, i18n.t("error"));
        }
      })
      .catch(err => {
        state.loadContact = false
        data.self.$toastr("error", err.message, i18n.t("error"));
      });
  },
  saveEditContact({ getters }, data) {
    let save_contact = Object.assign ({}, state.contact)
    save_contact.company = save_contact.company[0];
    if (save_contact.language != null)
        save_contact.language = save_contact.language[0];

    return axios
      .post("/vue/contact/" + data.coid + "/edit/", save_contact, {
        headers: { Authorization: "Token " + getters.getUserToken }
      })
      .then(response => {
        if (!response.data.status) {
          let messages = response.data.messages.join ("<br>");
          return data.self.$toastr("error", messages, i18n.t("error"));
        } else {
          data.self.$router.push({ name: "contacts-overview" });
          data.self.$toastr("success", i18n.t("saved"), i18n.t("success"));
        }
      })
      .catch(err => {
        data.self.$toastr("error", err.message, i18n.t("error"));
      });
  },
  createContact({ getters }, data) {
    return axios
      .post(
        "/vue/company/" + data.cid + "/create/contact/",
        data.contact,
        { headers: { Authorization: "Token " + getters.getUserToken } }
      )
      .then(response => {
        if (!response.data.status) {
          var messages = "";
          for (var i = 0; i < response.data.messages.length; i++) {
            if (i == 0) {
              messages = response.data.messages[i];
            } else {
              messages = messages + "<br>" + response.data.messages[i];
            }
          }
          return data.self.$toastr("error", messages, i18n.t("error"));
        } else {
          data.self.$router.push({ name: "contacts-overview" });
          data.self.$toastr("success", i18n.t("saved"), i18n.t("success"));
        }
      })
      .catch(err => {
        data.self.$toastr("error", err.message, i18n.t("error"));
      });
  }
};

const mutations = {
  SET_CONTACTS(state, payload) {
    state.contacts = payload;
  },
  SET_CONTACT(state, payload) {
    state.contact = payload;
    if (state.contact.language === null) {
      state.contact.language = [null, ""]
    }
  }
};

const contactModule = {
  state: state,
  mutations: mutations,
  actions,
  getters
};

export default contactModule;
